import "./login.css";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "react-bootstrap/";
import { TextField, Button } from "@mui/material";
import { TailSpin } from "react-loader-spinner";
import axios from "../../network/api";
import Logo from "../../assets/images/logowithR.svg";
import { baseUrl } from "../../network/constants/Constants";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import AppConstants from "../AppContants";



function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [token, setToken] = useState("");
  const navigate = useNavigate();

  const handleEmail = (event) => {
    setEmail(event.target.value);
  };

  const handlePassword = (event) => {
    setPassword(event.target.value);
  };

  const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    setEmailError(!regex.test(email));
    return regex.test(email);
  };

  const validatePassword = (password) => {
    setPasswordError(password.length < 8);
    return password.length >= 8;
  };



  // const PostLogin = () => {
  //   setLoading(true);

  //   const payload = {
  //     email: email,
  //     password: password,
  //   };

  //   axios
  //     .post(baseUrl + "/auth/login/", payload)
  //     .then((response) => {
  //       console.log("Login successful:", response.data);
  //       setToken(response.data.token);
  //       setLoading(false);
  //       callDeleteAPI();
  //     })
  //     .catch((error) => {
  //       console.error("Login error:", error);
  //       setLoading(true);
  //     });
  // };
  const PostLogin = () => {
    setLoading(true);
    const payload = {
      email: email,
      password: password,
    };

    axios
      .post(baseUrl + "/auth/login/", payload)
      .then((response) => {
        console.log("Login successful:", response.data);
        const receivedToken = response.data.token;
        setToken(receivedToken);
        setLoading(false);
        callDeleteAPI(receivedToken);
      })
      // .catch((error) => {
      //   console.error("Login error:", error);
      //   setLoading(false);
      //   if (error.response && error.response.data) {
      //     toast.error(error.response.data.message || "Invalid Email or Password!");
      //   } else {
      //     toast.error("Something went wrong. Please try again!");
      //   }
      // });
      .catch((error) => {
        setLoading(false);
        if (error.response && error.response.data) {
          toast.error(error.response.data.message || "Please check your email!");
        } else {
          toast.error("Network Error! Please try again.");
        }
      });
  };


  // const callDeleteAPI = () => {


  //   setLoading(true);

  //   const config = {
  //     headers: { Authorization: `Token ${token}` }
  //   };

  //   axios
  //     .get(baseUrl + "/auth/delete-account/", config)
  //     .then((response) => {
  //       setLoading(false);
  //       navigate("../deleted", { replace: true });
  //       console.log(response.data);
  //     })
  //     .catch((error) => {
  //       console.log(error + "errrorrriiii");
  //       setLoading(true);
  //     });
  // };
  const callDeleteAPI = (authToken) => { // receive token as parameter
    setLoading(true);
    const config = {
      headers: { Authorization: `Token ${authToken}` } // use parameter, not state
    };

    // axios
    //   .get(baseUrl + "/auth/delete-account/", config)
    //   .then((response) => {
    //     setLoading(false);
    //     navigate("../deleted", { replace: true });

    //     console.log(response.data);
    //   })
    //   .catch((error) => {
    //     console.log(error + "errrorrriiii");
    //     setLoading(false); // ← fix this too
    //   });
    axios
      .get(baseUrl + "/auth/delete-account/", config)
      .then((response) => {
        setLoading(false);

        // --- Green Toastify Success Message ---
        toast.success("Successfully Deleted!", {
          position: "top-right",
          autoClose: 2000, // 2 second kaanikkan
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored", // Ithu kodukkunnath nalla green color kittaanaanu
        });

        console.log(response.data);

        // Toast user-u onnu kaanan vendi 2 second kazhinju navigate cheyyaam
        setTimeout(() => {
          navigate("../deleted", { replace: true });
        }, 2500);
      })
      .catch((error) => {
        console.log(error + " errorriiii");
        setLoading(false);
        toast.error("Deletion Failed! Please try again.");
      });
  };

  return (
    <section id="login">
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="content">
        {/* Top Logo Section */}
        <div className="logo-container">
          <img src={Logo} alt="Logo" className="logo" />
          <div className="neis-text">NEIS Edu App</div>
        </div>

        {/* Login Card */}
        <Card className="login-card">
          <div className="login-title">Login</div>


          <TextField
            id="email"
            className="mt-3 text-border"
            placeholder="Email"
            variant="outlined"
            fullWidth
            InputLabelProps={{ shrink: false }} // Label gap ozhivaakkan
            value={email}
            onChange={handleEmail}
            error={emailError}
            helperText={emailError ? "Check your email" : ""}
          />

          <TextField
            id="password"
            className="mt-4 text-border"
            placeholder="Password"
            variant="outlined"
            fullWidth
            type="password"
            InputLabelProps={{ shrink: false }}
            value={password}
            onChange={handlePassword}
            error={passwordError}
            helperText={passwordError ? "Check your password" : ""}
          />

          <Button
            variant="contained"
            className="login-btn mt-5"
            // onClick={() => {
            //   if (validateEmail(email) && validatePassword(password)) {
            //     setLoading(true);
            //     PostLogin();
            //   }
            // }}
            onClick={() => {
              const isEmailValid = validateEmail(email);
              const isPasswordValid = validatePassword(password);

              if (!isEmailValid) {
                toast.error("Please check your email!");
              } else if (!isPasswordValid) {
                toast.error("Please check your password!");
              } else {
                PostLogin();
              }
            }}
          >
            SUBMIT
          </Button>

          {/* Loader */}
          <div style={{ display: "flex", justifyContent: "center", marginTop: "15px" }}>
            <TailSpin
              height="30"
              width="30"
              color="#ffbe00"
              visible={loading}
            />
          </div>
        </Card>
      </div>

      <a href="tel:" className="contact">
        ⓘ Contact Us
      </a>
    </section>
  );
}

export default Login;
